// src/pages/DriverLogin.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";
import foodLogo from "../images/logo-food1.avif";
import api from "../utils/api";


export default function DriverLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      
  const res = await api.post("/driver/auth/login", {
  	email,
  	password,
	});



      // Save token + driver info
      // Save token + driver info
	localStorage.setItem("driver_token", res.data.token);   // ✅ match dashboard
	localStorage.setItem("driver", JSON.stringify(res.data.driver));


      // Redirect to driver dashboard
      navigate("/driver/dashboard");
    } catch (err) {
      setError(err?.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="bg-overlay" />
      <main className="login-card" role="main" aria-labelledby="driverLoginTitle">
        <img src={foodLogo} alt="Brand" className="brand" />
        <h1 id="driverLoginTitle"> Driver Login</h1>

        {error && <div className="alert">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />

          <label htmlFor="password">Password</label>
          <div className="password-row">
            <input
              id="password"
              type={showPw ? "text" : "password"}
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
            <button
              type="button"
              className="eye"
              aria-label={showPw ? "Hide password" : "Show password"}
              onClick={() => setShowPw((v) => !v)}
            >
              {showPw ? "🙈" : "👁️"}
            </button>
          </div>

          <button className="submit" type="submit" disabled={loading}>
            {loading ? "Logging in…" : "Login"}
          </button>
        </form>

        <div className="meta">
          <Link to="/driver/forgot-password">Forgot password?</Link>
          <span>•</span>
          <Link to="/driver">Create account</Link>
        </div>
      </main>
    </div>
  );
}

